import { ImageControl } from 'components/organisms/PageEditor/componentControls/ImageControl';
import { InteractiveChartControl } from 'components/organisms/PageEditor/componentControls/InteractiveChartControl';
import { InteractiveMapControl } from 'components/organisms/PageEditor/componentControls/InteractiveMapControl';
import { LinkControl } from 'components/organisms/PageEditor/componentControls/LinkControl';
import { ListControl } from 'components/organisms/PageEditor/componentControls/ListControl';
import { RowControl } from 'components/organisms/PageEditor/componentControls/RowControl';
import { SectionControl } from 'components/organisms/PageEditor/componentControls/SectionControl';
import { SpacerControl } from 'components/organisms/PageEditor/componentControls/SpacerControl';
import { TableControl } from 'components/organisms/PageEditor/componentControls/TableControl';
import { TypographyControl } from 'components/organisms/PageEditor/componentControls/TypographyControl';
import {
    OneOfComponentsConfigs,
    PageComponentConfig,
} from 'types/builder/componentConfig';

type ControlConfig = {
    [K in PageComponentConfig['component']]: unknown;
};
type ControlChildConfig = {
    [K in PageComponentConfig['component']]: boolean;
};
type NewComponentDefaultProps = {
    [K in PageComponentConfig['component']]: OneOfComponentsConfigs;
};

export const controlConfig: Partial<ControlConfig> = {
    typography: TypographyControl as unknown,
    spacer: SpacerControl as unknown,
    row: RowControl as unknown,
    section: SectionControl as unknown,
    list: ListControl as unknown,
    simpleLink: LinkControl as unknown,
    image: ImageControl as unknown,
    box: 'div',
    interactiveMap: InteractiveMapControl as unknown,
    table: TableControl as unknown,
    interactiveChart: InteractiveChartControl as unknown,
};

export const controlChildConfig: ControlChildConfig = {
    box: true,

    col: true,

    image: false,
    list: false,

    row: true,
    section: true,
    simpleLink: false,
    spacer: false,

    typography: false,

    interactiveMap: false,
    table: false,
    interactiveChart: false,
};

export const newComponentDefaultProps: Partial<NewComponentDefaultProps> = {
    typography: {
        component: 'typography',
        props: {
            children: 'Текст',
            variant: 'body.medium',
        },
    },
    simpleLink: {
        component: 'simpleLink',
        props: {
            children: 'Ссылка',
        },
    },
    list: {
        component: 'list',
        props: {
            items: ['Элемент', 'Элемент', 'Элемент'],
        },
    },
    section: {
        component: 'section',
        props: {
            showInHeader: true,
        },
    },
    table: {
        component: 'table',
    },
    interactiveChart: {
        component: 'interactiveChart',
        props: {
            config: {
                type: 'bar',
            },
        },
    },
};
